import Vue from 'vue'

import Popup from './popup'

// 获取组件构造器
const PopupBox = Vue.extend(Popup)

export default {
    install (Vue, options) {
        Vue.prototype.popup = function(data) {
            let instance = new PopupBox({ data }).$mount()
            document.body.appendChild(instance.$el)
            Vue.nextTick(() => {
                instance.show = true
            })
        }
        
    }
}